var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group"},[_vm._m(0),_c('input',{staticClass:"form-control float-right calendario",attrs:{"type":"text","placeholder":this.placeholder || 'mm/dd/yyyy'}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"far fa-calendar-alt"})])])
}]

export { render, staticRenderFns }